module.exports = __webpack_public_path__ + "static/media/cp4.0cc34b6e.png";